var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "bmui-empty" }, [
    _c("i", { staticClass: "bmui-empty-img" }),
    _vm._v(" "),
    _c("p", { staticClass: "bmui-empty-text" }, [
      _vm._v(_vm._s(_vm.title || "暂无数据"))
    ]),
    _vm._v(" "),
    _vm.btn
      ? _c(
          "button",
          { staticClass: "bmui-empty-btn", attrs: { type: "button" } },
          [_vm._v(_vm._s(_vm.btn))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42dcf356", { render: render, staticRenderFns: staticRenderFns })
  }
}